/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::9ae74867f1789d6fd7191d9c53bc2726>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen dtac
 */
import { useCallback } from 'react';

import { useAnalyticsEvents as useAnalyticsNextEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { EVENT_CHANNEL } from '../constants';
import type { EventKey } from './analytics.types';
import createEventPayload, { type EventPayloadAttributes } from './create-event-payload';

type FireEventFn = <K extends EventKey>(eventKey: K, ...params: EventPayloadAttributes<K>) => void;

export const useAnalyticsEvents = (): { fireEvent: FireEventFn } => {
	const { createAnalyticsEvent } = useAnalyticsNextEvents();
	const fireEvent = useCallback(
		<K extends EventKey>(...params: Parameters<typeof createEventPayload<K>>): void => {
			const event = createAnalyticsEvent(createEventPayload<K>(...params));
			event.fire(EVENT_CHANNEL);
		},
		[createAnalyticsEvent],
	) as FireEventFn;
	return {
		fireEvent,
	};
};
